// import * as sha1 from 'js-sha1'
import tinycolor from 'tinycolor2'
import store from '@/store'
import constants from '@/constants'
import _ from 'lodash'
import system from './system'
import availability from './availability'
// const aux = {
//   // translation: function (value, locale, language) {
//   //   let aux = value
//   //   try {
//   //     aux = JSON.parse(value)
//   //   } catch (e) {}
//   //   if (aux[locale]) {
//   //     return aux[locale]
//   //   } else if (aux['en']) {
//   //     return aux['en']
//   //   } else {
//   //     const firstKey = Object.keys(aux)[0]
//   //     return aux[firstKey]
//   //   }
//   // },
//   verifyURL: function (url) {
//     if (url.indexOf('www') >= 0 || url.indexOf('http') >= 0) return url
//     return `${window.location.protocol}//www.${url}`
//   }
// }

const utils = {
  getNewID () {
    const uuidv4 = require('uuid/v4')
    return uuidv4()
  },
  isTotem () {
    return screen && navigator && screen.width===1080 && screen.height===1920 && navigator.userAgent.indexOf('Windows') != -1 && navigator.userAgent.indexOf('Chrome') != -1
  },
  getWidthPaddingDiff(width, padding) {
    if (!padding) return width
    const p = padding.split('px').map(item => item ? item | 0 : null)
    return width - (p[1] + p[3])
  },
  setCustomToken (key, value) {
    localStorage.setItem(key, value)
  },
  validateEmail (v) {
    return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(v)
  },
  getCustomToken (key) {
    const aux = localStorage.getItem(key)
    return aux && aux.length > 0 ? aux : null
  },
  getOppositeColor (v) {
    return tinycolor(v).isLight() ? '#000000' : '#FFFFFF'
  },
  getWorkspaceIdentification () {
    const domainNotValid = ['dtouch',  'dtouchwebapp', 'localhost']
    const domain = this.getDomain()

    return domainNotValid.indexOf(domain) >= 0 ? this.getWorkspace() : domain
  },
  getYearsByDays (v) {
    let result = ''
    let year = (v / 365) | 0
    if (year > 0) result += `${year}y `
    let days = v - (year * 365) | 0
    result += `${days}d`
    return result
  },
  getWorkspace() {
    return this.getEnterpiseID()
  },
  convertTime (v) {
    if (!v) return '00:00'

    const h = v / 60 | 0
    const m = v - (h * 60)
    return `${this.pad(h)} : ${this.pad(m)}`
  },
  addMinutes(date, minutes) {
    const d = typeof date === 'string' ? new Date(date) : date
    return new Date(d.getTime() + minutes * 60000)
  },
  checkRedirect () {
    let url = null
    if(this.getDomain() === 'orthobiomsk')  url = 'https://orthobiomsk.es'

    if (url) window.location.href = url
  },
  isLopesanDomain () {
    const location = window.location
    return location.host.indexOf('.lopesan.') > 0 || location.host.indexOf('.dtouch.local') > 0
  },
  urlExists(url) {
    try {
      const http = new XMLHttpRequest()
      http.open('HEAD', url, false)
      http.send()
      return http.status != 404
    } catch {
      return false
    }
  },
  formatNumber(value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  },
  replaceAll(string, search, replace) {
    return string ? string.split(search).join(replace) : ''
  },
  transfMenu (oldValue, newValue) {
    if (!oldValue.noRestore) { // se utilizar para cuando se guarda la edición del menú [formMenu/index]
      oldValue.Name = newValue.Name
      oldValue.Menus = newValue.Menus
      oldValue.Type = newValue.Type
      // oldValue.IsMenuWithSubmenu = newValue.IsMenuWithSubmenu
    }
  },
  getParameterByName (name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
    results = regex.exec(location.hash);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  },
  isMobile () {
    if (window.location.hash.indexOf('/totem') >= 0 || this.isTotem()) return false
    if (this.getParameterByName('fm')) return true
    if (navigator.userAgent.match(/iPad/i) != null) return false
    if (navigator.userAgent.match(/Mobi/)) return true
    if ('screen' in window && window.screen.width <= 800 && window.screen.height <= 600) return true

    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection
    if (connection && connection.type === 'cellular') return true

    return false
  },
  isIpad () {
    return navigator.userAgent.match(/iPad/i) != null
  },
  getDefaultContentByType (menuType, ord, BGColor) {
    let result = {}
    if (menuType === 2) { // TITLE
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        Title: { es: ''},
        Style: {
          SizeMult: 0,
          ToUpperCase: false,
          TextAlign: 'left'
        }
      }
    } else if (menuType === 3) { // SPACE
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        Size: 10
      }
    } else if (menuType === 4) { // IMAGE
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        Image: null
      }
    } else if (menuType === 5) { // IFRAME
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        URL: null,
        Height: 600
      }
    } else if (menuType === 6) { // ALERT
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        AlertText: { es: ''},
        Icon: 'mdi-information',
        BGColor: BGColor,
        Color: BGColor
      }
    } else if (menuType === 7) { // GALLERY
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        Images: [],
      }
    } else if (menuType === 8) { // VIDEO
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        VideoURL: null,
        TypeVideo: 'youtube'
      }
    } else if (menuType === 9) { // METEO
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType
      }
    } else if (menuType === 10) { // Map
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        Height: 600,
        Lat: 40.419008,
        Lon: -3.703927
      }
    } else if (menuType === 11) { // TWITTER
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        Account: 'descubretv'
      }
    } else if (menuType === 12) { // FACEBOOK
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        Account: 'descubregroup'
      }
    } else if (menuType === 13) { // ACTIVITY
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        TypeActivity: 0
      }
    } else if (menuType === 14) { // PDF
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        URL: null,
        DownloadPdf: false
      }
    } else if (menuType === 15) { // TIMELINE
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        TimelineDate: new Date().toISOString().slice(0, 10),
        TimelineImage: 'https://cdn.vuetifyjs.com/images/cards/forest.jpg',
        Times: [],
        TimeLineTextHeader: { es: ''},
        TimeLineSubTextHeader: { es: ''},
      }
    } else if (menuType === 16) { // TEXT
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        Text: { es: ''},
      }
    } else if (menuType === 17) { // CONTACT
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        HideDivider: false,
        ContactItems: []
      }
    } else if (menuType === 18) { // DIVIDER
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        DividerUp: 0,
        DividerDown: 0,
        DividerLeft: 15,
        DividerRight: 15,
        DividerDark: false,
      }
    } else if (menuType === 19) { // SHOW
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        TypeShow: 0
      }
    } else if (menuType === 20) { // SITE
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        SiteImage: null,
        SiteTitle: { es: ''},
        SiteSubtitle: { es: ''},
        SiteMoreInfo: { es: ''},
        SiteAdress: '',
        SiteLat: '',
        SiteLon: '',
        SitePhone: '',
        SiteWeb: '',
        SiteEmail: '',
        SiteLink: false,
        SiteLinkURL: { es: '' },
        SiteLinkName: { es: '' },
        SiteLinkDialog: false,
      }
    } else if (menuType === 23) { // WIFI
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        WifiName: { es: ''},
        WifiIsWep: false,
        WifiSSID: '',
        WifiPassword: ''
      }
    } else if (menuType === 27) { // food/drink
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        FoodName: { es: '' },
        FoodIngredients: { es: '' },
        FoodPrice: null,
        FoodNote: { es: '' },
        FoodVegan: false,
        FoodVegetarian: false,
        FoodNew: false,
        FoodRecommended: false,
        FoodAllergens: [],
        FoodImage: null
      }
    } else if (menuType === 28) { // link domain
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        LinkDomain: '',
        LinkDomainName: { es: '' },
      }
    } else if (menuType === 29) { // form
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        FormIcon: '',
        FormRoomNumber: false,
        FormDateTime: false,
        FormNumberOfPeople: false,
        FormTextBtn: { es: '' },
        FormTimetable: null,
        FormLimitNumberOfItem: 99,
        FormLblNumberOfItem: { es: 'Número de personas', en: 'Number of people' }
      }
    } else if (menuType === 30) { // product/service
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        ProductName: { es: '' },
        ProductDescription: { es: '' },
        ProductNote: { es: '' },
        ProductPrice: null,
        ProductPromotion: false,
        ProductImage: null
      }
    } else if (menuType === 31) { // PDFTranslate
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        URLPdfTranslate: { es: null},
        DownloadPdfTranslate: false,
        PDFTranslateLink: false,
        PDFTranslateLinkName: { es: null},
      }
    } else if (menuType === 32) { // LinkExternal
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        LinkExternal: { es: '' },
        LinkExternalName: { es: '' },
        LinkExternalNewTab: true
      }
    } else if (menuType === 26) { // QUEUE
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        QueueID: ''
      }
    } else if (menuType === 21 || menuType === 22 || menuType === 24 || menuType === 25) { // AGENDA, PARRILLA, PROPERTY, COMMERCIAL
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType
      }
    } else if (menuType === 33) { // CHANNEL LIST
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        ChannelListType: 0
      }
    } else if (menuType === 34) { // ACTIVITY ACTTIV
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        ActtivPrimaryColor: null,
        ActtivSecundaryColor: null,
        ActtivColor: null
      }
    } else if (menuType === 35) { // poll
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        PollAlias: '',
        PollFormData: null,
        UpdateKey: null
      }
    } else if (menuType === 36) { // INSTAGRAM
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        InstagramIframe: ''
      }
    } else if (menuType === 37) { // ICONLIST
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        IconListImage: null,
        IconListTitle: { es: '' },
        IconListDescription: { es: '' },
      }
    } else if (menuType === 38) { // dropdownButton
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        DropdownButtonTitle: { es: '' },
        DropdownButtonBGColor: '#3094F7',
        DropdownButtonTextColor: '#FF5733'
      }
    } else if (menuType === 39) { // dfiles
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
      }
    } else if (menuType === 40) { // r-covid
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        RCovidName: '',
        RCovidNI: '',
        RCovidPhone: ''
      }
    } else if (menuType === 41) { // imageTranslate
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        ImageTranslateURL: { es: null},
      }
    } else if (menuType === 42) { // iberistarFood
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        IberostarFoodRestaurant: null,
        IberostarFoodPrimaryBGColor: '#000000',
        IberostarFoodPrimaryTextColor: '#FFFFFF',
        IberostarFoodSecondaryBGColor: '#000000',
        IberostarFoodSecondaryTextColor: '#FFFFFF',
        IberostarFoodPrimaryTextFormat: 1,
        IberostarFoodSecondaryTextFormat: 1,
      }
    } else if (menuType === 43) { // icons
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        IconsURL: 'https://www.dtouch.es/assets/ima_icon_dtouch.jpg',
        IconsAlign: 'center'
      }
    } else if (menuType === 44) { // hsconsulting
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        //HsconsultingHotelID: '106',
        //HsconsultingInstallationID: '223',
        HsconsultingHotelID: null,
        HsconsultingInstallationID: null,
      }
    } else if (menuType === 45) { // brochure 
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        //BrochureImage: 'https://www.webtenerife.com/es/interes/empresas-servicios-turista/empresas-excursiones/publishingimages/ariki-travel-ppalweb.jpg',
        BrochureImage: null,
        BrochureTitle: { es: null },
        BrochureSubtitle: { es: null },

        BrochureWithDescription: false,
        BrochureDescription: { es: null },
        BrochureNote: { es: null },
          BrochureWithFacts: false,
        BrochureHours: { es: null },
        BrochurePrice: { es: null },
        BrochureServices: { es: null },
          BrochureWithLocation: false,    
        BrochureZone: null,
        BrochureMunicipaly: null,
        BrochureAddress: null,
        BrochurePostalCode: null,
        BrochureLat: null,
        BrochureLon: null,
          BrochureWithContact: false,
        BrochurePhone: null,
        BrochureFax: null,
        BrochureEmail: null,
        BrochureWeb: null,
          BrochureWithPDF: false,
        BrochurePDF: null,
        BrochureOpenNewTab: false,
        BrochureDownload: false
        
      }
    } else if (menuType === 46) { // infoten
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        InfotenFilters: { 
          Activo: '1',
          Asociado: '1',
          Legalizacion: 'Si',
        },
      }
    } else if (menuType === 47) { // cm my booking
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
      }
    } else if (menuType === 48) { // cm activities
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
      }
    } else if (menuType === 49) { // menu ext food
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        MenuExtFoodExternalID: null,
      }
    } else if (menuType === 50) { // cm attendance
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        AttendanceWorkspaceID: null,
      }
    } else if (menuType === 51) { // cm weekly menu
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
      }
    } else if (menuType === 54) { // FormCIO
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
      }
    } else if (menuType === 55) { // dviewcontentMessages
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        DviewcontentMessagesTitleColor: '#000000',
        DviewcontentMessagesDescriptionColor: '#000000',
      }
    } else if (menuType === 56) { // servatur
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
      }
    } else if (menuType === 57) { // InteractiveMaps
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        InteractiveMapsID: null,
      }
    } else if (menuType === 58) { // AbamaRequestReservation
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
      }
    } else if (menuType === 59) { // EFFILabel
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
      }
    } else if (menuType === 60) { // EFFIWaste
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
      }
    } else if (menuType === 62) { // CHEKIN
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
      }
    } else if (menuType === 63) { // Q&A
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
        QAndAQuestion: { es: '' },
        QAndAAnswer: { es: '' },
      }
    } else if (menuType === 64) { // MediaFeed
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
      }
    } else if (menuType === 65) { // AbamaLinkRoom
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
      }
    } else if (menuType === 66) { // AbamaRequest
      result = {
        ID: `new_${_.uniqueId()}`,
        IsNew: true,
        Type: menuType,
      }
    }


    
    result.ORD = ord
    return result
  },
  removeNewNew (menus) {
    return menus.filter(x => !x.isNew)
  },
  getUserID () {
    return localStorage.getItem('user') 
  },
  getEnterpiseID () {
    return localStorage.getItem('enterprise') 
  },
  isPrivate: function () {
    const host = window.location.host
    const parts = host.split('.')
    const domainLength = 3 // route1.example.com => domain length = 3
    if (parts.length === (domainLength - 1)) {
      return true
    } else if (parts[0] === 'www') {
      if (parts[0] === 'www' && (parts[1] === 'admin' || parts[1] === process.env.VUE_APP_URL)) {
        return true
      }
    } else if (parts[0] === 'admin') {
      return true
    }

    return false
  },
  isActive (availability, daysToAdd = 0, timeZone = 'Europe/London') {    
    if (store.state.app.TimeZone) timeZone = store.state.app.TimeZone
    const isDebug = false
    if (!availability || availability.Per == null) {
      return {
        date: true,
        time: true,
        finished: false,
        daysToAdd: daysToAdd
      }
    }
    const result = {
      date: false,
      time: false,
      finished: false,
      daysToAdd: daysToAdd
    }
    
    // verificamos el hora
    if (availability.IsAllTimes) result.time = true
    else {
      if (availability.TimeStart > availability.TimeEnd) {
        // invert time
        const now = system.getNowMinutes(timeZone)
        const { TimeStart, TimeEnd } = availability
        if ((now >= 0 && now <= TimeEnd) || (TimeStart <= now && now <= 1440)) result.time = true
      } else {
        // normal time
        if (system.tSMt(availability.TimeStart, null, timeZone) && system.tGTt(availability.TimeEnd, null, timeZone)) result.time = true 
        if (daysToAdd === 0 && system.tSMt(availability.TimeEnd, null, timeZone)) result.finished = true
      }
    }

    if (isDebug) console.log('availability', availability)

    // [X] PER = 1 fecha evento
    // [X] PER = 2 recurrencia
        // [X] REC = 1 semana
        // [X] REC = 0 mes
    // [X] PER = 0 fecha inicio-fin
    
    if (availability.Per === 1) {
      if (isDebug) console.log('Entra por Evento')
      // ################################# fecha evento
      if (system.dtEQdt(availability.DateStart, null, daysToAdd)) {
          result.date = true
      } else result.date = false
    } else if (availability.Per === 2 || availability.Per === 0) {
      if (isDebug) console.log('DateStart: ', availability.DateStart)
      if (isDebug) console.log('DateEnd: ', availability.DateEnd)
      if (isDebug) console.log('IsAllDays: ', availability.IsAllDays)
      if (system.dtSMdt(availability.DateStart, null, daysToAdd)  && (system.dtGTdt(availability.DateEnd, null, daysToAdd) || availability.IsAllDays)) {
        // validamos la fecha de inicio
        if (availability.Per === 2) {
          if (isDebug) console.log('Entra por Recurrencia')
          // ################################# recurrencia
          if (availability.Rec === 1) {
            if (isDebug) console.log('Entra por Semana', availability.DayOfWeek)
            // --------------------------------- semana
            const dayWeek = system.getDayOfWeek(daysToAdd)
            if (availability.DayOfWeek.indexOf(dayWeek) >= 0 && system.alternation(availability.DateStart, daysToAdd, availability.Alt, false)) result.date = true
          } else {
            if (isDebug) console.log('Entra por Mes')
            // --------------------------------- mes
            const dayMonth = system.getMonth(daysToAdd)
            if (availability.DayOfMonth.indexOf(dayMonth) >= 0 && system.alternation(availability.DateStart, daysToAdd, availability.Alt, true)) result.date = true
          }
        } else {
          if (isDebug) console.log('Entra por INI-FIN')
          // ################################# fecha inicio-fin
          result.date = true
        }
      }
    }
    if (isDebug) console.log('result', result)
    return result
  },
  checkAvailabilityStatus (value) {
    if (typeof value !== 'object') value = JSON.parse(value)
    if (!value) value = {}
    
    value.status = this.isActive(value)
    return value
  },
  // checkAvailabilityItem (item) {
  //   console.log('jhm2222', item)
  //   // if (typeof item.Availability !== 'object') item.Availability = JSON.parse(item.Availability)    
  //   // item.Availability = JSON.parse(item.Availability)    
  //   // item.isActive = this.isActive(item.Availability)
  //   item.isActive = {
  //     date: true,
  //     time: true,
  //     finished: false,
  //     daysToAdd: 0
  //   }
  //   return item
  // },
  // checkAvailability (menus) {
  //   return menus.map(item => {
  //     return this.checkAvailabilityItem(item)
  //     // item.Availability = JSON.parse(item.Availability)
  //     // item.isActive = this.isActive(item.Availability)
  //     // if (!item.isActive.time) console.log('jhm444', item.Name, item.isActive)
  //     // return item
  //   })

  // },
  getDomain () {
    const getHostname = window.location.hostname
    return getHostname.split('.')[0] === 'www' ? getHostname.split('.')[1] : getHostname.split('.')[0]
  },
  getAPIURL: function (path, isPrivate, id) {
    const hostname = window.location.hostname
    const pathSplit = hostname.split('.')
    let domain = ''
    if (pathSplit.length > 2) {
      domain = pathSplit[0] === 'www' ? pathSplit[1] : pathSplit[0]
    }
    if (domain === process.env.VUE_APP_API_URL.split('.')[0] || domain === 'admin') domain = ''
    domain = !isPrivate && domain.length === 0 ? id : domain
    const area = isPrivate ? 'private' : 'public'
    let www = process.env.VUE_APP_ENV === 'development' ? '' : 'www.'
    let result = `${window.location.protocol}//${www}${process.env.VUE_APP_API_URL}/${area}/${path}`
    // old 2090806
    // if (id && isPrivate) result = `${result}/${id}`
    // // return isPrivate ? result.concat(`?token=${localStorage.getItem('jwt')}`) : result.concat(`?domain=${domain}`)
    // return isPrivate ? result.concat(`?token=${localStorage.getItem('jwt')}`) : result.concat(`/${domain}`)
    // old 2090806
    // new 2090806
    if (id && isPrivate) result = `${result}/${id}`
    // return isPrivate ? result.concat(`?token=${localStorage.getItem('jwt')}`) : result.concat(`?domain=${domain}`)
    return isPrivate ? result.concat(`?token=${localStorage.getItem('jwt')}`) : id ? result.concat(`/${id}`) : result.concat(`/${domain}`)
    // new 2090806
  
  },
  getAllLanguages (selectedLanguages) {
    const languages = []
    for (var key in constants.isoLangs) {
      languages.push({
        ID: key,
        Name: constants.isoLangs[key].nativeName.split(', ').join('-')
      })
    }
    if (selectedLanguages) {
      return selectedLanguages.map(item => {
        return languages.filter(x => x.ID === item).shift()
      })
      //return languages.filter(x => selectedLanguages.indexOf(x.ID) >= 0)
    }
    return languages
  },
  setActiveEnterprise: function (v_, enterprise, redirect) {
    if (enterprise) {
      localStorage.setItem('enterprise', enterprise.ID)
      v_.$store.state.app.enterpriseID = enterprise ? enterprise.ID : null
      v_.$store.state.app.dtouchWorkspace = enterprise ? enterprise.ID : null
      v_.$store.state.app.enterpriseName = enterprise ? enterprise.Name : ''
      v_.$store.state.app.enterpriseColor = enterprise ? enterprise.PrivateBGColor : 'primary'
      if (enterprise) v_.$vuetify.theme.themes.light.primary = enterprise.PrivateBGColor.length > 7 ? enterprise.PrivateBGColor.substring(0,7) : enterprise.PrivateBGColor
      v_.$store.state.app.btnBackgroundColor = enterprise ? enterprise.BtnBackgroundColor : 'primary'
      v_.$store.state.app.btnTextColor = enterprise ? enterprise.BtnTextColor : 'primary'
      v_.$store.state.app.foodDrinkTextColor = enterprise ? enterprise.FoodDrinkTextColor : 'primary'      
    }
    if (redirect) {
      console.log('234')
      v_.$router.push('/dashboard')
    }
  },
  getActiveEnterpriseID: function (v_) {
    return (v_.$store.state.app.enterpriseID)
  },
  getActiveEnterpriseColor: function (v_) {
    return (v_.$store.state.app.enterpriseColor)
  },
  checkIsActive(menu) {
    if (!menu.IsTemp) {
      return true
    } else {
      if (menu.StartDate <= new Date() && (menu.EndDate >= new Date() || menu.NoEndDate)) {
        return true
      } else {
        return false
      }
    }
  },
  getStringETC: function (value, limit) {
    if (!value) return ''
    return value.length > limit ? value.substring(0, limit).concat('...') : value
  },
  convertEspecialChar (value) {
    return value ? value.split('#$#').join("'") : null
    // return value.replaceAll('#$#', "'")
  },
  getTranslation(value, locale) {
    if (!value) return 
    let aux = value
    if (typeof aux === 'string') aux = JSON.parse(aux)
    // try {
    //   aux = JSON.parse(value)
    // } catch (e) {
    //   console.log(e)
    // }
    if (aux[locale]) {
      return this.convertEspecialChar(aux[locale])
    } else if (aux['en']) {
      return this.convertEspecialChar(aux['en'])
    } else {
      const firstKey = Object.keys(aux)[0]
      return this.convertEspecialChar(aux[firstKey])
    }
  },
  pad: function (value, nItem = 2) {
    let aux = ''
    for (let i = 0; i < nItem; i++) aux = aux.concat('0')
    let result = aux.concat(value)
    result = result.substring(result.length - nItem, result.length)
    return result
  },
  // setActiveEnterprise: function (v_, enterprises, noRedirect) {
  //   const selectEnterprise = enterprises.length > 0 ? enterprises[0] : enterprises
  //   //localStorage.setItem('enterprise', JSON.stringify(selectEnterprise))
  //   v_.$store.state.app.image = selectEnterprise.Banner && selectEnterprise.Banner.length > 0 ? aux.verifyURL(selectEnterprise.Banner) : ''
  //   v_.$store.state.app.enterpriseName = selectEnterprise.Name && selectEnterprise.Name.length > 0 ? selectEnterprise.Name : ''
  //   v_.$store.state.app.enterpriseID = selectEnterprise.ID && selectEnterprise.ID.length > 0 ? selectEnterprise.ID : ''
  //   if (!noRedirect) v_.$router.push('/dashboard')
  // },
  // getAllLanguages (selectedLanguages) {
  //   const languages = []
  //   for (var key in constants.isoLangs) {
  //     languages.push({
  //       ID: key,
  //       Name: constants.isoLangs[key].nativeName.split(', ').join('-')
  //     })
  //   }
  //   if (selectedLanguages) {
  //     return languages.filter(x => selectedLanguages.indexOf(x.ID) >= 0)
  //   }
  //   return languages
  // },
  // getAllMenuType () {
  //   const menuType = []
  //   for (var key in constants.menuType) {
  //     menuType.push({
  //       ID: constants.menuType[key],
  //       Name: key
  //     })
  //   }
  //   return menuType
  // },
  // isAdmin: function () {
  //   return localStorage.getItem('role') === sha1('1')
  // },
  // isSuperuser: function () {
  //   return localStorage.getItem('role') === sha1('-1')
  // },
  // setActiveEnterprise: function (v_, enterprise, noRedirect) {
  //   const selectEnterprise = enterprise.length > 0 ? enterprise[0] : enterprise

  //   localStorage.setItem('enterprise', JSON.stringify(selectEnterprise))
  //   v_.$store.state.app.image = selectEnterprise.Banner && selectEnterprise.Banner.length > 0 ? aux.verifyURL(selectEnterprise.Banner) : ''
  //   v_.$store.state.app.enterpriseName = selectEnterprise.Name && selectEnterprise.Name.length > 0 ? selectEnterprise.Name : ''
  //   v_.$store.state.app.enterpriseID = selectEnterprise.ID && selectEnterprise.ID.length > 0 ? selectEnterprise.ID : ''
  //   if (!noRedirect) v_.$router.push('/dashboard')
  // },
  // getActiveEnterprise: function () {
  //   const enterprise = JSON.parse(localStorage.getItem('enterprise'))
  //   // console.log(enterprise.Languages)
  //   try {
  //     enterprise.Languages = enterprise.Languages.toString().split(',')
  //   } catch (error) {
  //     console.error(error)
  //   }
  //   // console.log(enterprise.Languages)
  //   try {
  //     enterprise.Carousel = enterprise.Carousel ? enterprise.Carousel.toString().split(',') : []
  //   } catch (error) {
  //     console.error(error)
  //   }
  //   return enterprise
  // },
  // getActiveUser: function () {
  //   return JSON.parse(localStorage.getItem('user'))
  // },
  // getDomain: function () {
  //   const getHostname = window.location.hostname
  //   return getHostname.split('.')[0] === 'www' ? getHostname.split('.')[1] : getHostname.split('.')[0]
  // },
  // verifyURL: function (url) {
  //   return aux.verifyURL(url)
  // },
  // getPublicURL: function (domain) {
  //   return `${window.location.protocol}//www.${domain}.${process.env.VUE_APP_API_URL}`
  // },
  // getTranslation: function (value, locale, language) {
  //   return aux.translation(value, locale, language)
  // },
  // prepareMenu: function (menus, locale, language, expandPref) {
  //   const result = []
  //   menus.forEach(function (element) {
  //     // if (element.Content) {
  //     //   element.Content = element.Content
  //     //   try {
  //     //     element.Content = JSON.parse(element.Content)
  //     //   } catch (error) {}
  //     // }
  //     element.T_Name = aux.translation(element.Name, locale, language)
  //     element.submenus = menus.filter(x => x.ParentID === element.ID)
  //     if (expandPref) {
  //       if (expandPref.content) {
  //         element.isExpand = true
  //       } else if (element.submenus.length > 0 && expandPref.submenu) {
  //         element.isExpand = true
  //       } else {
  //         element.isExpand = false
  //       }
  //     }
  //     result.push(element)
  //   })
  //   return result.filter(x => !x.ParentID)
  // },
  // checkAvailability: function (availability) {
  //   if (!availability.IsTemp) return true
  //   if (availability.IsTemp && (new Date() >= new Date(availability.StartDate) && (new Date() <= new Date(availability.EndDate) || availability.NoEndDate))) {
  //     return true
  //   }
  //   return false
  // }
  minutesToHHMM: function (value) {
    let mins_num = parseFloat(value, 10); // don't forget the second param
    let hours   = Math.floor(mins_num / 60);
    let minutes = Math.floor((mins_num - ((hours * 3600)) / 60));
    let seconds = Math.floor((mins_num * 60) - (hours * 3600) - (minutes * 60));

    // Appends 0 when unit is less than 10
    if (hours   < 10) {hours   = "0"+hours;}
    if (minutes < 10) {minutes = "0"+minutes;}
    if (seconds < 10) {seconds = "0"+seconds;}
    return hours+':'+minutes
  },
  convertMinutesToTime (value) {
    let aux = value / 60
    const hours = aux > 0 ? parseInt(aux) : 0
    const minutes = value - (hours * 60)
    return {
      hours,
      minutes
    }
  },
  checkAvailability (v, daysToAdd = 0, timeZone = 'Europe/London') {
    return availability.check(v, daysToAdd, timeZone)
  },
  checkIsActive (v, daysToAdd = 0, timeZone = 'Europe/London') {
    return availability.checkIsActive(v, daysToAdd, timeZone)
  },
}

export default utils
